/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for Impact Evaluation Bar Chart 
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from "react";
import { Card, CardBody, Button, Row, Alert, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import { useParams } from "react-router-dom";
import { getPetition } from "../../../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import { saveFile, rawDataIntoExcel } from "../../../../api/excel-api";
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../../core/models/colors";
import useDebounce from '../../../../hooks/useDebounce'
import Select, { components } from 'react-select';
import Switch from "react-switch";
import { toast } from 'react-toastify';
export default function DifferentPMD({ spacecraftId, spacecraftIdOrigin, missionName, missionId, constellation }) {


  const { id } = useParams();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [PMDoptions, setPMDoptions] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [exporting, setExporting] = useState(false)
  const [dropdownOpenMission, setdropdownOpenMission] = useState(false);
  const [idArray, setIdArray] = useState([]);
  const toggle2 = () => setdropdownOpenMission((prevState) => !prevState);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [missionOptions, setMissionOptions] = useState([]);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [spacecraftsIdArray, setSpacecraftIdArray] = useState([])
  const [missionNamesArray, setMissionNamesArray] = useState([])
  const [graphData, setGraphData] = useState([{}])
  const [dataPerPmd, setDataPerPmd] = useState({})
  const [draft, setDraft] = useState(false)
  const [logartihmic, setLogartihmic] = useState(false)

  const changeLogartihmic = () => {
    setLogartihmic(!logartihmic)
    const series = graphData.map((item) => {
      const data = item.data.map((e) => {
        if (!logartihmic) {
          return Math.log10(e)
        } else {
          return Math.pow(10, e)
        }
      })
      return {  
        name: item.name,
        data: data
      }
    })
    setGraphData(series)
  }


  useEffect(() => {
    if (spacecraftId === null && spacecraftIdOrigin && spacecraftIdOrigin[0] && idArray.length === 0 && !constellation) {
      setLoading(true)
      getPetition(`/api/debris_index/debris_index_per_phase_for_spacecraft?spacecraft_id=${spacecraftIdOrigin[0]}`)
        .then((data) => {
          setMissionNamesArray([missionName])
          setDataPerPmd([data])
          getBarChartData([data])
          setLoading(false)
          setError(false)
        })
        .catch((error) => {
          setLoading(false)
          setError(true)
        })
    } else {
      if (idArray.length > 0) {
        const spacecraftsIds = []
        idArray.forEach((mission) => {
          getPetition(`/api/mission/object_data?mission_id=${mission.value}`)
            .then((data) => {
              data?.map((item) => {
                if (item.space_vehicle_id) {
                  spacecraftsIds.push({
                    value: item.space_vehicle_id,
                    label: mission.name
                  
                  })

                  if (idArray.length === spacecraftsIds.length) {
                    spacecraftsIds.unshift({ value: spacecraftIdOrigin[0], label: missionName })
                    setSpacecraftIdArray(spacecraftsIds)
                  }
                }
              })
            })
            .catch((error) => {
              console.log(error)
            })


        })
      }
      else if (constellation && spacecraftId !== null) {
        getPetition(`/api/debris_index/debris_index_per_phase_for_spacecraft?spacecraft_id=${spacecraftId}`)
          .then((data) => {
            setMissionNamesArray([missionName])
            setDataPerPmd([data])
            getBarChartData([data])
            setLoading(false)
            setError(false)
          })
          .catch((error) => {
            setLoading(false)
            setError(true)
          })
      }
      else if (constellation && spacecraftId === null) {
        getPetition(`/api/debris_index/debris_index_per_phase_for_constellation?mission_id=${missionId}`)
          .then((data) => {
            setMissionNamesArray([missionName])
            setDataPerPmd([data])
            getBarChartDataConstellation([data])

            setLoading(false)
            setError(false)
          })
          .catch((error) => {
            setLoading(false)
            setError(true)
          })
      }

    }
  }, [spacecraftId, id, PMDoptions, spacecraftIdOrigin, idArray, missionName, constellation, missionId]);

  useEffect(() => {
    setMissionOptions([])
  }, [draft])
  useEffect(() => {
    if (spacecraftsIdArray.length > 0) {

      setLoading(true)
      const dataMission = []

      spacecraftsIdArray.map((item, index) => {
        if (index !== 0) {
          missionNamesArray.push(item.label)
        }
        getPetition(`/api/debris_index/debris_index_per_phase_for_spacecraft?spacecraft_id=${item.value}`)
          .then((data) => {
            dataMission.push(data)
            if (dataMission.length === spacecraftsIdArray.length) {
              getBarChartData(dataMission)
              setLoading(false)
            }
            setError(false)
          })
          .catch((error) => {
            setLoading(false)
            setError(true)
          })
      })


    }
  }, [spacecraftsIdArray, spacecraftIdOrigin]);


  const fetchDataToExcel = () => {
    setExporting(true)
    const excelRows = [];
    graphData.map((item, index) => {
      const excelRow = {
        mission: missionNamesArray[index] ? missionNamesArray[index] : missionName,
        launch: item.data[0],
        injection: item.data[1],
        operational: item.data[2],
      }
      if (PMDoptions !== 'no_disposal') {
        excelRow.no_pmd = item.data[3]
      } else {
        excelRow.no_disposal = item.data[3]
      }
      if (PMDoptions === 'targeted_disposal') {
        excelRow.targeted_disposal = item.data[4]
      } else if (PMDoptions === 'direct_disposal') {
        excelRow.direct_disposal = item.data[4]
      } else if (PMDoptions === 'reorbit_disposal') {
        excelRow.reorbit_disposal = item.data[4]
      }
      excelRows.push(excelRow)
    })

    const excelData = rawDataIntoExcel(excelRows, 'Total index per phase')
    saveFile(excelData, 'Total index per phase')
    setExporting(false)
  }

  const getLabel = (label) => {
    if (label === 'no_disposal') {
      return 'No Disposal'
    } else if (label === 'targeted_disposal') {
      return 'Target-time deorbit'
    } else if (label === 'direct_disposal') {
      return 'Direct Disposal'
    } else if (label === 'reorbit_disposal') {
      return 'Target-orbit deorbit'
    } else {
      return 'No PMD'
    }
  }


  const getCategorieLabels = () => {
    const categoriesLabels = ['Launch', 'Injection', 'Operational'];
    if (PMDoptions !== 'no_disposal') {
      categoriesLabels.push('No PMD')
    } else {
      categoriesLabels.push('No disposal')
    }
    if (PMDoptions === 'targeted_disposal') {
      categoriesLabels.push('Target-time deorbit')
    }
    else if (PMDoptions === 'direct_disposal') {
      categoriesLabels.push('Direct Disposal')
    }
    else if (PMDoptions === 'reorbit_disposal') {
      categoriesLabels.push('Target-orbit deorbit')
    }
    return categoriesLabels;
  }

  const getCategoriesConstellation = () => {
    const categoriesLabels = ['Deployment', 'Operational', 'Decommissioning'];
    return categoriesLabels;
  }

  const apexBarChartOpts = {
    chart: {
      height: 380,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,

      },
    },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val.toExponential(2)
      },

      style: {
        fontSize: '10px',
        colors: ['#fff'],
      },
    },
    colors: ESA_COLORS,
    stroke: {
      show: true,
      width: 0.2,
      colors: ['#fff'],
    },
    xaxis: {
      categories: (constellation && spacecraftId === null) ? getCategoriesConstellation() : getCategorieLabels(),
      labels: {
        show: true,
        rotateAlways: false,

        rotate: 0,
        style: {
          colors: [],
          fontSize: '10px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 400,

          cssClass: 'apexcharts-xaxis-label',
        },
        offsetX: 0,


      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {

          return  val.toExponential(3) 
        },
      },
      forceNiceScale: false,
      tickAmount: 4,
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      showForNullSeries: true,
      showForZeroSeries: true,
    },
    states: {
      hover: {
        filter: 'none',
      },
    },
    grid: {
      borderColor: '#f1f3fa',
    },
  };


  const getBarChartDataConstellation = (data) => {
    const decommissioning = [];
    const deployment = [];
    const operational = [];

    if (data && data.length > 0) {
      data.map((spacecraft, index) => {
        decommissioning.push(parseFloat(spacecraft.decommissioning).toExponential(3));
        deployment.push(parseFloat(spacecraft.deployment).toExponential(3));
        operational.push(parseFloat(spacecraft.operational).toExponential(3));
      });
    }

    const barChartData = [

      {
        name: 'Deployment',
        data: deployment,
      },
      {
        name: 'Operational',
        data: operational,
      },
      {
        name: 'Decompossioning',
        data: decommissioning,
      },
    ];
    const series = []

    data.map((item, index) => {
      const seriesData = barChartData.map((e) => logartihmic ? Math.log10(e.data[index]) :  e.data[index]);
      series.push({
        name: missionNamesArray[index] ? missionNamesArray[index] : missionName,
        data: seriesData,
      })
    })
    

    setGraphData(series)
  }

  const getBarChartData = (data) => {
    const injection = [];
    const launch = [];
    const operational = [];
    const no_pmd = [];
    const targeted_disposal = [];
    const direct_disposal = [];
    const reorbit_disposal = [];
    const no_disposal = [];

    if (data && data.length > 0) {
      data.map((spacecraft, index) => {
        injection.push(parseFloat(spacecraft.injection).toExponential(3));
        launch.push(parseFloat(spacecraft.launch).toExponential(3));
        operational.push(parseFloat(spacecraft.operational).toExponential(3));
        if (PMDoptions !== 'no_disposal') {
          no_pmd.push(parseFloat(spacecraft?.no_pmd?.toExponential(3)));
        } else {
          no_disposal.push(parseFloat(spacecraft?.pmd?.no_disposal?.toExponential(3)));
        }
        if (PMDoptions === 'targeted_disposal') {
          if (spacecraft?.pmd?.targeted_disposal) {
            targeted_disposal.push(parseFloat(spacecraft.pmd.targeted_disposal.toExponential(3)));
          } else {
            targeted_disposal.push(0);
          }
        } else if (PMDoptions === 'direct_disposal') {
          if (spacecraft?.pmd?.direct_disposal) {
            direct_disposal.push(parseFloat(spacecraft.pmd.direct_disposal.toExponential(3)));
          } else {
            direct_disposal.push(0);
          }
        } else if (PMDoptions === 'reorbit_disposal') {
          if (spacecraft?.pmd?.reorbit_disposal) {
            reorbit_disposal.push(parseFloat(spacecraft.pmd.reorbit_disposal.toExponential(3)));
          } else {

            reorbit_disposal.push(0);
          }
        }
      });
    }
    const barChartData = [
      {
        name: 'Launch',
        data: launch,
      },
      {
        name: 'Injection',
        data: injection,
      },
      {
        name: 'Operational',
        data: operational,
      }
    ];

    if (PMDoptions !== 'no_disposal') {
      barChartData.push({
        name: 'No PMD',
        data: no_pmd,
      })
    } else {
      barChartData.push({
        name: 'No disposal',
        data: no_disposal,
      })
    }

    if (PMDoptions === 'targeted_disposal') {


      barChartData.push({
        name: 'Target-time deorbit',
        data: targeted_disposal,
      })
    } else if (PMDoptions === 'direct_disposal') {

      barChartData.push({
        name: 'Direct Disposal',
        data: direct_disposal,
      })

    } else if (PMDoptions === 'reorbit_disposal') {

      barChartData.push({
        name: 'Target-orbit deorbit',
        data: reorbit_disposal,
      })

    }

    const series = []
    data.map((item, index) => {
      const seriesData = barChartData.map((e) => logartihmic ? Math.log10(e.data[index]) :  e.data[index]);
      series.push({
        name: missionNamesArray[index] ? missionNamesArray[index] : missionName,
        data: seriesData,
      })
    })
    setGraphData(series)
  };
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const IndicatorsContainer = (props) => {
    const { inputValue, onInputChange } = props.selectProps;
    const debouncedInputValue = useDebounce(inputValue, 1000);
    useEffect(() => {
      if (debouncedInputValue !== '') {

        getPetition(`/api/missions?limit=5&draft=${draft}&exclude_const=true&name=` + debouncedInputValue)
          .then((data) => {
            if (data.missions) {

              onInputChange('', { action: 'set-value' })
              setMissionOptions(data.missions)

            }
          })

      }
    }, [debouncedInputValue, onInputChange]);
    return (
      <div style={{}}>
        <components.IndicatorsContainer {...props} className="input-group">

        </components.IndicatorsContainer>
      </div>
    );
  };

  const Control = ({ children, ...props }) => {

    return (
      <components.Control onChange={(e) => console.log(e)} {...props}>
        {children}
      </components.Control>
    );
  };
  const sendSelectedMissions = () => {
    if (optionsSelected.length > 0) {
      const ids = optionsSelected.map((option) => {
        return {value: option.value, name: option.label}
      })
      setIdArray(ids)
      setdropdownOpenMission(false)
    }
  }

  const MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {/* menu header */}

        {props.children}
      </components.MenuList>
    );
  };
  const formateOptions = (options) => {

    if (options.length > 0) {
      const optionsSelect = options.slice(0, 5).map((option, index) => ({
        value: option?.id || option?.value,
        label: option?.name || option?.label
      }))
      return optionsSelect
    }
  }

  const checkOption = (e) => {
    if (e.length > 2 && optionsSelected.length < e.length) {
      toast.warning('You can only select 2 missions')
    } else {
      setOptionsSelected(e)
    }
  }
  const restoreMissionsSearch = () => {
    console.log('restore')
    setIdArray([])
    setSpacecraftIdArray([])
    setOptionsSelected([])
    setdropdownOpenMission(false)
  }

  const checkPMDphases = (data, option) => {
    let check = false
    if (option === 'no_disposal') {
      data.map((item) => {
        if (item?.pmd?.no_disposal) {
          check = true
        }
      })
    } else if (option === 'targeted_disposal') {
      data.map((item) => {
        if (item?.pmd?.targeted_disposal) {
          check = true
        }
      })
    } else if (option === 'direct_disposal') {
      data.map((item) => {
        if (item?.pmd?.direct_disposal) {
          check = true
        }
      })
    } else if (option === 'reorbit_disposal') {
      data.map((item) => {
        if (item?.pmd?.reorbit_disposal) {
          check = true
        }
      })
    }
    return check
  }
  useEffect(() => {
    if(dataPerPmd.length && checkPMDphases(dataPerPmd, 'targeted_disposal') && PMDoptions==='Target-time deorbit'){
      setPMDoptions('targeted_disposal')
    }else if(dataPerPmd.length && checkPMDphases(dataPerPmd, 'direct_disposal') && PMDoptions==='Direct Disposal'){
      setPMDoptions('direct_disposal')
    }else if(dataPerPmd.length && checkPMDphases(dataPerPmd, 'reorbit_disposal') && PMDoptions==='Target-orbit deorbit'){
      setPMDoptions('reorbit_disposal')
    }else if(dataPerPmd.length && checkPMDphases(dataPerPmd, 'no_disposal') && PMDoptions==='No Disposal'){
      setPMDoptions('no_disposal')
    }
  }, [dataPerPmd, PMDoptions])
  if (loading) {
    return (
      <Card className="widget-flat h-100">
        <CardBody>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
            <Spinner animation="border" role="status"></Spinner>
          </div>
        </CardBody>
      </Card>
    )
  }
  if (error) {
    return (
      <Card className="widget-flat h-100">
        <CardBody>
          <Alert color="danger" role="alert">
            <h4 className="alert-heading">Error</h4>
            <p>There was an error processing this request. Please try again later.</p>

            <div className="btn-list mt-4" style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
              <Button color="danger" onClick={() => restoreMissionsSearch()}><i className="uil uil-refresh"></i></Button>
            </div>
          </Alert>
        </CardBody>

      </Card>
    )
  }

  return (
    <Card className="widget-flat h-100 ">
      <CardBody>
        <Row >
          <h4 style={{ color: '#003247' }} className="header-title float-left col " >DEBRIS INDEX PER PHASE</h4>
         
          
          {!error &&
            <>
              <Col>
                {(!constellation || spacecraftId !== null) &&
                  <Dropdown className="float-right" isOpen={dropdownOpen} toggle={toggle} >
                    <DropdownToggle style={{ background: "#003247", fontSize: '11px' }} caret>{getLabel(PMDoptions)}</DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem disabled={dataPerPmd.length && !checkPMDphases(dataPerPmd, 'no_disposal')} onClick={() => setPMDoptions('no_disposal')}>No Disposal</DropdownItem>
                      <DropdownItem disabled={dataPerPmd.length && !checkPMDphases(dataPerPmd, 'targeted_disposal')} onClick={() => setPMDoptions('targeted_disposal')}>Target-time deorbit</DropdownItem>
                      <DropdownItem disabled={dataPerPmd.length && !checkPMDphases(dataPerPmd, 'direct_disposal')} onClick={() => setPMDoptions('direct_disposal')}>Direct Disposal</DropdownItem>
                      <DropdownItem disabled={dataPerPmd.length && !checkPMDphases(dataPerPmd, 'reorbit_disposal')} onClick={() => setPMDoptions('reorbit_disposal')}>Target-orbit deorbit</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                }


                {(!constellation || spacecraftId !== null) &&
                  <Dropdown isOpen={dropdownOpenMission} toggle={toggle2} >
                    <DropdownToggle style={{ background: '#003247', fontSize: '11px' }} className="float-right">+</DropdownToggle>
                    <DropdownMenu style={{ width: '150%', height: 'auto' }}>
                      <Card>
                        <CardBody>
                          <Row style={{ marginBottom: '10px' }}>
                            <Col xs={8}>
                              <h5 style={{ color: '#003247' }} className="header-title float-left col " >Select Missions</h5>
                            </Col>
                            <Col xs={4}>
                              <div style={{ display: 'flex', width: '100%', alignContent: 'center', justifyContent: 'right', }}>
                                <span style={{ color: '#003247', display: 'flex', marginLeft: 13, marginRight: 10 }} >Planned</span>
                                <Switch
                                  checked={draft}
                                  onChange={() => setDraft(!draft)}
                                  onColor="#009bdb"
                                  onHandleColor="#003247"
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                  height={15}
                                  width={30}

                                  handleDiameter={20}
                                  className="react-switch"
                                  id="material-switch"
                                />
                              </div>
                            </Col>
                          </Row>
                          <div className="mb-2 position-relative">
                            <Select
                              placeholder={'Search...'}
                              options={formateOptions(missionOptions)}
                              isMulti={true}
                              limit={3}
                              components={{ Control, MenuList, IndicatorsContainer }}
                              maxMenuHeight="350px"
                              closeMenuOnSelect={false}
                              controlShouldRenderValue={true}
                              handleClick={onClick}
                              blurInputOnSelect={false}
                              isSearchable
                              value={optionsSelected}
                              className="dropdown"
                              isClearable={false}
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                checkOption(e)
                              }}
                            />
                            <Row>
                              {
                                spacecraftsIdArray.length > 0 &&
                                <Col>
                                  <Button
                                    onClick={() => { restoreMissionsSearch() }}
                                    className="btn btn-primary btn-block"
                                    style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                                  >
                                    Restore
                                  </Button>
                                </Col>
                              }

                              <Col>
                                <Button
                                  onClick={() => { sendSelectedMissions() }}
                                  className="btn btn-primary btn-block"
                                  style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                                >
                                  Submit
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </CardBody>
                      </Card>

                    </DropdownMenu>
                  </Dropdown>
                }
                <Button disabled={exporting} onClick={() => fetchDataToExcel()} style={{ background: '#003247', fontSize: '11px' }} className="float-right"><i className="uil  uil-down-arrow "></i></Button>
              </Col>
            </>
          }
          
        </Row>
        <div style={{ width:'100%',display: 'flex',alignContent: 'center', justifyContent: 'left', marginTop: 10 }}>
              <span style={{ color: '#003247', display: 'flex', marginLeft: 13, marginRight: 10 }} >Log scale</span>
              <Switch
                checked={logartihmic}
                onChange={() => changeLogartihmic()}
                onColor="#009bdb"
                onHandleColor="#003247"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={15}
                width={30}
                handleDiameter={20}
                className="react-switch"
                id="material-switch"
              />
            </div>
        {error ?
          (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
              <Alert color="warning">
                <h4 className="alert-heading">No data available</h4>
                <p>
                  There is no data available for this mission.
                </p>
                <div className="btn-list mt-4" style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                  <Button color="warning" onClick={() => restoreMissionsSearch()}><i className="uil uil-refresh"></i></Button>
                </div>
              </Alert>
            </div>
          )
          :
          (
            <div style={{ width: '100%' }}>
              {loading ?
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                  <Spinner animation="border" />
                </div>
                :

                <Chart
                  options={apexBarChartOpts}
                  series={graphData}
                  type="bar"
                  className="apex-charts"
                  width={'100%'}
                />
              }
            </div>)
        }

      </CardBody>
    </Card>
  );
}
